import { focusOutline, spacing, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const menu: ThemeUICSSObject = {
  /* PREPEND HERE */
  left: 0,
  top: '32px',
  position: 'fixed',
  bottom: 0,
  zIndex: 'menu',

  '&.hidden': {
    display: 'none',
  },

  '.menu__content': {
    background: 'palette.background.paper',
    borderLeft: '1px solid',
    borderTop: 'none',
    borderRight: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'palette.border.section',
    color: 'palette.text.primary',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 32px)',
    minWidth: 'min(450px, 100vw)',
    maxWidth: 'min(650px, 100vw)',
    overflow: 'hidden',
  },

  '.menu__searchBox': {
    background: 'palette.background.paper',
    position: 'sticky',
    top: 0,
    p: spacing(5),
  },

  '.menu__toggleFavoriteButton': {
    flexShrink: 0,
    svg: {
      color: 'favorite',
      path: { fill: 'form.fields.disabled.backgroundColor' },
    },
    '&.favorite': {
      svg: {
        color: 'favorite',
        path: { fill: 'favorite' },
      },
    },
  },

  '.menu__element': {
    textAlign: 'left',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  '.tree__nodeItemLabelRenderer': {
    width: '100%',
  },

  '.menu__openTask': {
    textAlign: 'left',
    width: '100%',
  },

  '.menu__openTask:focus': focusOutline,

  '.menu__resultsBox': {
    overflow: 'auto',
    height: '100%',
    pl: spacing(5),
    pr: spacing(5),
    pb: spacing(5),
    pt: 0,
  },

  '.tree__nodeItemLabel': (theme) => ({
    width: '100%',

    ...theme.palette.getStatesFromDefinition({
      backgroundColor: theme.palette.background.paper,
    }),
  }),

  '.tree__mainLabel': {
    '&:focus': focusOutline,
  },

  input: {
    borderColor: 'palette.border.section',
    borderRadius: '2px',
    p: spacing(3),
    zIndex: 1,

    '&:focus': focusOutline,
  },
};

export default menu;
